import React from "react";

export const CalendarPage = () => {

  return (
    <div className="mt-8">
      {/* <div className="flex items-center staticBanner bg-[#eac7a3] relative">
        <div className="staticBannerContent">
          <img
            src="/images/unitBanner.svg"
            alt="banner"
            className="staticBannerImg"
          />
          <div className="text-base sm:text-lg md:text-3xl absolute w-[40%] max-w-[400px] -translate-x-1/4 max-h-full">
            <h2 className=" font-black text-primaryDark">我們的使命與價值</h2>
            <p className="text-secondaryDark mt-[0.5em] text-[0.65em] leading-normal">
              為全面推動中小學數位學習精進方案，協助學校提高數位教學與學習品質及成效，高雄市政府教育局成立數位學習推動辦公室。
            </p>
          </div>
        </div>
      </div> */}
      <div className="content px-4 mx-auto pt-2">
        {/* <div className="text-xl md:text-2xl font-medium text-Headline mt-12 md:mt-16 mb-6 md:mb-8">
            行事曆
          </div> */}
        <div className="padlet-embed" style={{ border: '1px solid rgba(0,0,0,0.1)', borderRadius: '2px', boxSizing: 'border-box', overflow: 'hidden', position: 'relative', width: '100%', background: '#F4F4F4' }}>
          <p style={{ padding: '0', margin: '0' }}>
            <iframe src="https://affairs.kh.edu.tw/calendar/view/6856/82" style={{ width: '100%', height: '70vh', display: 'block', padding: '0', margin: '0' }}></iframe>
          </p>
        </div>
      </div>

      <div className='p-6 lg:p-8'></div>
    </div>
  );
};
